import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Globals } from '../../globals';
import { FormGroup } from '@angular/forms';


//interface
interface Dish {
  UID: string;
  UID_RESTAURANT: string;
  name_es: string;
  allergens: object;
  recipe: string;
  tools: string;
  price: number;
  image: string;
  tags: object;
  time: string;
  foodcost: object;
  foodcost_parts: string;
  created_at: string;
  updated_at: string;
  price_half: number;
  price_tapa: number;
  name_ca: string;
  name_de: string;
  name_en: string;
  name_fr: string;
  name_it: string;
  description_es: string;
  description_ca: string;
  description_de: string;
  description_en: string;
  description_fr: string;
  description_it: string;
  foodcost_static: number;
  tpv_active: boolean;
  pos_favourite: boolean;
  variations_favourite: object;
  nutrition_100_energy: string;
  nutrition_100_fat: string;
  nutrition_100_saturate: string;
  nutrition_100_carbohydrate: string;
  nutrition_100_sugar: string;
  nutrition_100_fiber: string;
  nutrition_100_protein: string;
  nutrition_100_salt: string;
  nutrition_portion_energy: string;
  nutrition_portion_fat: string;
  nutrition_portion_saturate: string;
  nutrition_portion_carbohydrate: string;
  nutrition_portion_sugar: string;
  nutrition_portion_fiber: string;
  nutrition_portion_protein: string;
  nutrition_portion_salt: string;
  traces: string;
  price_supplement: any;
  price_combo_extra: any;
  price_takeaway: any;
}



@Injectable()
export class DishServices {
  public dish_tmp: Dish = {
    UID: '',
    UID_RESTAURANT: '',
    name_es: '',
    allergens: [],
    recipe: '',
    tools: '',
    price: 0,
    image: '',
    tags: [],
    time: '',
    foodcost: [],
    foodcost_parts: '',
    created_at: '',
    updated_at: '',
    price_half: 0,
    price_tapa: 0,
    price_supplement: 0,
    price_combo_extra: 0,
    price_takeaway: 0,
    name_ca: '',
    name_de: '',
    name_en: '',
    name_fr: '',
    name_it: '',
    description_es: '',
    description_ca: '',
    description_de: '',
    description_en: '',
    description_fr: '',
    description_it: '',
    foodcost_static: 0,
    tpv_active: true,
    pos_favourite: false,
    variations_favourite: [],
    nutrition_100_energy: '',
    nutrition_100_fat: '',
    nutrition_100_saturate: '',
    nutrition_100_carbohydrate: '',
    nutrition_100_sugar: '',
    nutrition_100_fiber: '',
    nutrition_100_protein: '',
    nutrition_100_salt: '',
    nutrition_portion_energy: '',
    nutrition_portion_fat: '',
    nutrition_portion_saturate: '',
    nutrition_portion_carbohydrate: '',
    nutrition_portion_sugar: '',
    nutrition_portion_fiber: '',
    nutrition_portion_protein: '',
    nutrition_portion_salt: '',
    traces: '',
  };


  private firestore: any;
  public image_url_dish_view: Observable<string | null>;
  dishesCol: AngularFirestoreCollection<Dish>;
  dishes: Observable<Dish[]>;
  dishes_variations: Observable<Dish[]>;
  dishDoc: AngularFirestoreDocument<Dish>;
  deleteStat: boolean = false;
  public quick_create: boolean = false;
  public quick_create_type: boolean = false;

  //TMP - Son variables a utilizar en diferentes puntos de la creacio/edicion para enviar modificar la informacion de diferentes componentes
  public dish_tags = Array();
  public dish_allergens_tmp = Array();

  public pagesDishes: any;
  public page_active: number = 1;
  public limit_pages = 100;
  public first_dish_name: any = [];
  public get_dishes_done: boolean = false;

  //form publico para usarlos en los components
  public form: FormGroup;
  public form_desc: FormGroup;

  public _dishes_array_tmp: any = [];
  public dishes_array: any = [];

  constructor(public afs: AngularFirestore,
    public http: HttpClient,
    public globals: Globals) {
    this.firestore = firebase.firestore();
  }

  getListDishes(UID_RESTAURANT) {
    this.dishesCol = this.afs.collection('dish', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('name_es', 'asc'));
    this.dishes = this.dishesCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Dish;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  getListDishesVariations(UID_RESTAURANT) {
    this.dishesCol = this.afs.collection('dish', ref => ref
      .where('UID_RESTAURANT', '==', UID_RESTAURANT)
      .orderBy('name_es', 'asc'));
    this.dishes_variations = this.dishesCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Dish;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  async getDishes(UID_RESTAURANT) {
    const dishRef = this.firestore.collection('dish');

    var dishes = [];

    await dishRef.where('UID_RESTAURANT', '==', UID_RESTAURANT).get()
      .then(snapshot => {
        snapshot.forEach(doc => {

          var dish = doc.data();
          dish.UID = doc.id;

          dishes.push(dish);
        });
      });

    return dishes
  }

  async getDish(uid) {
    const dishRef = this.firestore.collection('dish').doc(uid);

    var _dish;

    await dishRef.get().then(doc => {
      if (doc.exists) {
        _dish = doc.data();
        _dish.UID = doc.id;
      }
    });
    return _dish
  }

  delete(uid) {
    this.afs.doc('dish/' + uid).delete();
  }

  public filteredDishes: any;
  public filteredDishesActive: boolean = false;
  searchDishNode(value) {
    if (!value) {
      this.filteredDishesActive = false;
    } else {
      if (value.length >= 3) {
        const params = new HttpParams()
          .set('uid', this.globals.restaurant_uid)
          .set('filter_string', value.toLowerCase());
        this.http.post(this.globals.analytics_path + 'filter/dish', params, {})
          .subscribe(async res => {
            this.filteredDishes = res;
            if (this.filteredDishes.length != 0) {
              this.getFilterDish();
            } else {
              this.filteredDishesActive = true;
            }
          });
      } else {
        this.filteredDishesActive = false;
      }
    }
  }

  getFilterDish() {
    //Ordenamos el array
    this.filteredDishes.sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));

    //Recorremos el array filtrada
    this.filteredDishes.forEach(dish => {
      //Buscamos el plato en el array no filtrada de platos para ver los que no estan activos por version
      var index = this._dishes_array_tmp.findIndex(x => x.UID == dish.UID);
      if (index >= 0) {
        dish._active = this._dishes_array_tmp[index]._active;
      } else {
        dish._active = false;
      }
    });
    this.filteredDishesActive = true;
  }

  //PAGINATE
  async getPagesDishes(elements_per_page) {
    this.get_dishes_done = false;
    this.filteredDishesActive = false;
    this.limit_pages = elements_per_page;

    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid)
      .set('elements_per_page', elements_per_page);
    await this.http.post(this.globals.analytics_path + 'paginate/dish', params, {})
      .subscribe(async res => {
        this.pagesDishes = Array(res['pages']).fill(0).map((x, i) => i + 1); //Create an array for the loop of pages that start in 1
        this.first_dish_name = res['first_dishes_name'];
        this._dishes_array_tmp = res['list_dishes'];
        if (this.pagesDishes != 0) {
          this.getListDishesAllMinMax();
        } else {
          this.filteredDishesActive = true;
        }
      });
  }

  first_element: any;

  /*GET DISHES*/
  getListDishesAllMinMax() {
    this.get_dishes_done = true;

    //Ordenamos el array
    this._dishes_array_tmp.sort((a, b) => this.globals.nameLangSelectDish(a).localeCompare(this.globals.nameLangSelectDish(b)));

    //For para poner en activo los platos que puede ver el free.
    this._dishes_array_tmp.forEach((value, index) => {
      value._active = true;
      if (index >= this.globals.checkLimitsByLicense('dishes', 'max_dishes') && this.globals.checkLimitsByLicense('dishes', 'max_dishes') != -1) {
        value._active = false;
      }
    });
    if (this.limit_pages == 0) {
      this.dishes_array = this._dishes_array_tmp;
    } else {
      //Search for first element to start
      this.first_element = (this.page_active - 1) * this.limit_pages;
      //We slice the array with the first element, and the first element plus the limit to get the last index
      this.dishes_array = this._dishes_array_tmp.slice(this.first_element, this.first_element + this.limit_pages);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/dish/services.ts